module.exports = __webpack_public_path__ + "static/heromystuff-bg-75fe1b8a939bb2f10cfe691c352a836d.jpg";